import { useTranslation } from "react-i18next"

import Table, { Body, Header, HeaderCell } from "@/components/Table/Table"
import type { Ticket } from "@/types/ticketTypes"

import TicketItem from "./TicketItem"

export default function TicketsShow({ tickets }: { tickets: Ticket[] }) {
  const { t } = useTranslation()
  return (
    <div>
      <Table>
        <Header>
          <HeaderCell>{t("ticketsPage.table.no")}</HeaderCell>
          <HeaderCell>{t("ticketsPage.table.subject")}</HeaderCell>
          <HeaderCell>{t("ticketsPage.table.description")}</HeaderCell>
          <HeaderCell>{t("ticketsPage.table.status")}</HeaderCell>
          <HeaderCell>{t("ticketsPage.table.view")}</HeaderCell>
        </Header>
        <Body>
          {tickets.map((ele, index) => {
            return <TicketItem from={index + 1} key={ele.id} ele={ele} />
          })}
        </Body>
      </Table>
    </div>
  )
}
